/*
  Constants specific to the TEXT non-question type. See the `types.js` file containing
  all of the possible types for full documentation of what properties
  are allowed for each type in the questions data file.
 */

// Required
export const VALUE = 'value'
export const ADMUSR = 'ADMUSR'
export const MHEUSR = 'MHEUSR'
export const CSWRKR = 'CSWRKR'
export const CSDRWK = 'CSDRWK'
// Yes/No Constant
export const VALUE_Y = 'Y'
export const VALUE_N = 'N'
export const VALUE_YES = 'Yes'
export const VALUE_NO = 'No'
export const VALUE_TRUE = true
export const VALUE_FALSE = false

export const EN = 'en-US' // English
export const ES = 'es-ES' // spanish
export const PT = 'pt-BR' // Portuguese
export const ZH = 'zh-Hans' // Chinese (Simplified)
export const VI = 'vi-VI' // Vietnamese
export const HI = 'cy-HT' // Haitian Creole
